import React, { Component } from 'react'
import LeftDrawer from '../ui/drawer/LeftDrawer'
import history from '../../utils/routing/history'

const withLeftDrawer = BaseComponent => {
  class WithLeftDrawerWrapper extends Component {
    render() {
      const { location: { pathname } } = history

      if (pathname.indexOf('/app') === -1) return <BaseComponent {...this.props} />

      return (
        <LeftDrawer>
          <BaseComponent {...this.props} />
        </LeftDrawer>
      )
    }
  }

  return WithLeftDrawerWrapper
}

export default withLeftDrawer



// WEBPACK FOOTER //
// ./src/components/hocs/withLeftDrawer.js